// Constants
import { USER_CANCELING_ONBOARDING_CUSTOM_ACTION } from './constants/cancel-drop-modal-footer.handler.constants';
// Event Handlers
import { isCancelApplicationModal } from './utils/cancel-drop-modal-footer.handlers.utils';
// Types
import {
  CancelDropModalFooterBuilderHandlersType,
  CancelDropModalFooterMethodsHandlersType,
} from './types/cancel-drop-modal-footer.handlers.type';
// Utilities
import { cancelOnboardingProcessResolver } from '../resolvers/cancel-drop-modal-footer.resolver';

const confirmDropOnboardingProcessButtonClick = async ({
  handleSendCustomActionEvent,
  handleLogCallbackUrlCallEvent,
  handleConfirmCancelApplicationClickTracking,
  handleConfirmDropApplicationClickTracking,
  id,
  setLoading,
}: CancelDropModalFooterBuilderHandlersType): Promise<void> => {
  setLoading(true);

  isCancelApplicationModal(id)
    ? handleConfirmCancelApplicationClickTracking()
    : handleConfirmDropApplicationClickTracking();

  await handleSendCustomActionEvent(USER_CANCELING_ONBOARDING_CUSTOM_ACTION);
  await cancelOnboardingProcessResolver();
  handleLogCallbackUrlCallEvent();
};

const CancelDropModalFooterHandlers = (
  props: CancelDropModalFooterBuilderHandlersType
): CancelDropModalFooterMethodsHandlersType => ({
  handleConfirmDropOnboardingProcessButtonClick: () =>
    confirmDropOnboardingProcessButtonClick(props),
});

export { CancelDropModalFooterHandlers };
